import type { RegisterableHotkey } from '@tanstack/react-hotkeys'

/**
 * Single source of truth for transport shortcuts, shared by the hotkey
 * registrations, the button tooltips and the shortcuts modal.
 */
export const TRANSPORT_HOTKEYS = {
  next: 'Space',
  // Registered by hand in `use-start-show-hotkey`, see the note there.
  startShow: 'Alt+Space',
} as const satisfies Record<string, RegisterableHotkey>
